import React from 'react';
import { CloseIcon, MapMovePinIcon, ZoomInIcon, ZoomOutIcon } from '@routific/hive/v5';
import { PinDropMode } from '.';
import { MapControlItem } from '../../shared/MapBase/MapControlBar';

const toolbarButtons = (
  zoomIn: () => void,
  zoomOut: () => void,
  pinDrop: () => void,
  allowPinDrop: boolean,
  mode: PinDropMode = PinDropMode.VIEWING,
): MapControlItem[] => {
  const defaultButtons: MapControlItem[] = [
    {
      key: 'zoom-in',
      title: 'mapToolbar.zoom.in',
      icon: <ZoomInIcon size='md' />,
      onClick: zoomIn,
    },
    {
      key: 'zoom-out',
      title: 'mapToolbar.zoom.out',
      icon: <ZoomOutIcon size='md' />,
      onClick: zoomOut,
    },
  ];
  if (allowPinDrop) {
    defaultButtons.push({
      key: 'edit',
      title: mode === PinDropMode.EDITING ? 'mapToolbar.edit.exit' : 'mapToolbar.edit.select',
      icon: mode === PinDropMode.EDITING ? <CloseIcon size='md' /> : <MapMovePinIcon size='md' />,
      onClick: pinDrop,
    });
  }
  return defaultButtons;
};

export default toolbarButtons;
